import { render, staticRenderFns } from "./FreeTime.vue?vue&type=template&id=47d2d674&scoped=true"
import script from "./FreeTime.vue?vue&type=script&lang=js"
export * from "./FreeTime.vue?vue&type=script&lang=js"
import style0 from "./FreeTime.vue?vue&type=style&index=0&id=47d2d674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d2d674",
  null
  
)

export default component.exports